<template>
  <div>
    <Header />
    <b-container v-if="global_loading">
      <div class="spinner-border space-above-container primary-text-color" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </b-container>
    <div v-else>
      <b-container class="space-above-container primary-text-color">
        <b-row>
          <b-col>
            <CustomSearch :items="search_items" :placeholder="placeholder" @update="set_item"></CustomSearch>
          </b-col>
          <b-col>
            <b-button v-on:click="search_key" style="float:left" type="submit">Search</b-button>
          </b-col>
        </b-row>
      </b-container>
      <hr />
      <b-row class="space-above">
        <b-col>
          <!-- <h2>{{this.$route.query.type}}</h2> -->
          <h3>{{this.script}}</h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="1">
        </b-col>
        <b-col cols="10">
          <b-row style="background-color:#ADD8E6; margin:1px;min-height:60px; padding-top:13px">
            <b-col cols="1">
              <span><strong>Name</strong></span>
            </b-col>
            <b-col cols="7">
              <a><span><strong>Uploaded By</strong></span></a>
            </b-col>
            <b-col cols="1">
              <span><strong>Upvote</strong></span>
            </b-col>
            <b-col cols="1">
              <span><strong>Downvote</strong></span>
            </b-col>
            <b-col cols="2">
              <span><strong>Toggle</strong></span>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="1">
        </b-col>
        <b-col cols="10">
          <div v-for="docker in dockers" :key="docker.key">
            <b-row style="background-color:#ADD8E6; margin:2px;min-height:60px; padding-top:13px">
              <b-col cols="1">
                <a href="#"><span>{{docker.display_name}}</span></a>
              </b-col>
              <b-col cols="7">
                <span>{{docker.user}}</span>
              </b-col>
              <b-col cols="1">
                <!-- <b-button style="margin-left:20px; float;left" type="submit" @click="upvote_downvote('vpvote',)">Upvote</b-button> -->
                <a href="#" type="submit" @click="upvote_downvote('vpvote',)" ><span><i class="fa fa-thumbs-up"></i></span></a> &nbsp;
                <span>{{docker.plus}}</span>
              </b-col>
              <b-col cols="1">
                <!-- <b-button style="margin-left:20px; float;left" type="submit" @click="upvote_downvote('downvote',)">Downvote</b-button> -->
                <a href="#" type="submit" @click="upvote_downvote('vpvote',)"><span><i class="fa fa-thumbs-down"></i></span></a> &nbsp;
                <span>{{docker.plus}}</span>
              </b-col>
              <b-col cols="1" v-on:click="toogle_show(docker.key)">
                <a href="#"><span><i style="float:right;" class="fa fa-caret-down"></i></span></a>
              </b-col>
            </b-row>
            <b-row v-if="!display_toggle[docker.key]" style="margin:2px;">
              <b-container>
                <b-row style="background-color:#F1F1F1; margin:2px;min-height:60px;">
                  <b-col>
                    <table>
                      <tr style="height:50px;margin:0;padding-left:-100px;" v-for="ls in docker.line_script" :key="ls">
                        <td style="height: 50px; background-color: #F1F1F1;margin:0;padding:0;">$</td>
                        <!-- <td class="left-text-align" style="padding-left: 20px;"> -->
                          <pre style="text-align: left; height: 50px; margin: 0; padding: 0; overflow: hidden;">
                            <code style="text-align: left; height: 50px; max-height: 50px; overflow: hidden; margin: 0; padding: 0;" class="language-bash">
                              {{ls}}
                            </code>
                          </pre>
                        <!-- </td> -->
                      </tr>
                    </table>
                  </b-col>
                </b-row>
                <hr/>
                <!-- <b-row style="margin-top:20px;">
                  <span><i style="margin-right:20px; float;left" class="fa fa-plus fas"></i><strong> {{docker.plus}}
                    </strong>
                    <b-button style="margin-left:20px; float;left" type="submit" @click="upvote_downvote('vpvote',)">Upvote</b-button>
                  </span>
                </b-row>
                <b-row style="margin-top:20px;">
                  <span><i style="margin-right:20px; float;left" class="fa fa-minus fas"></i><strong> {{docker.minus}}
                    </strong>
                    <b-button style="margin-left:20px; float;left" type="submit" @click="upvote_downvote('downvote',)">Downvote</b-button>
                  </span>
                </b-row> -->
                <!-- <b-row>
                  <h6 style="float:left; margin-top:20px">TESTED USING</h6>
                </b-row>
                <b-row>
                  <b-col>
                    <table>
                      <tr v-for="ts in docker.line_cmd" :key="ts">
                        <td style="min-width: 10px; background-color: #f8f8ff;">-</td>
                        <td class="left-text-align" style="padding-left: 20px;">
                          <pre>{{ts}}</pre>
                        </td>
                      </tr>
                    </table>
                  </b-col>
                </b-row> -->
              </b-container>
            </b-row>
          </div>
        </b-col>
        <b-col cols="1">
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import Header from './Header.vue';
  import CustomSearch from './CustomSearch.vue';
  import axios from 'axios';
  import store from  '@/store/store';
  import Prism from 'prismjs';
  import 'prismjs/components/prism-bash'
  import 'prismjs/themes/prism.css'
  export default {
    name: 'Script',
    components: {
      Header,
      CustomSearch
    },
    data() {
      return {
        script: this.$route.params.script,
        items: [],
        tags: [],
        filtered_items: [],
        filtered_tag: '',
        search_item: {},
        search_items: [
          { name: 'python 11' },
          { name: 'postgres 11' },
          { name: 'mongodb 12' },
          { name: 'postgres 14' },
        ],
        applications: [],
        dockers: [],
        search_type: '',
        placeholder: "Search by Application",
        display_toggle: {},
        global_loading: false,
      }
    },
    methods: {
      custom_search(search) {
        this.script = search;
        this.fetch_search();
      },
      fetch_search() {
        const search_name = this.script;
        const base_url = this.$route.query.type === "Docker" ? 'https://9d0o217t3j.execute-api.us-east-1.amazonaws.com/Prod/global_installer_find_docker_images?search=' : 'https://9d0o217t3j.execute-api.us-east-1.amazonaws.com/Prod/global_installer_find_applications?search=';
        this.global_loading = true;
        axios
          .get(base_url + search_name)
          .then(response => {
            console.log(response);
            if (response && response['data'][0] && response['data'][0]['searched_by']) {
              this.search_type = response['data'][0]['searched_by'];
              this.search_type = this.search_type.charAt(0).toUpperCase() + this.search_type.slice(1)
            }
            this.dockers = response['data'];
            this.dockers.forEach((doc,index) => {
              doc['line_script'] = doc['script'].split("&&");
              this.$set(this.display_toggle, index, false);
              doc['key'] = index;
              doc['line_cmd'] = doc['test_cmd'].split("&&");

            });
          }).catch(error => {
            console.log(String(error));
          }).finally(
            () => {
              this.global_loading = false;
            }
          );

      },
      filter_item(search_tag) {
        if (!search_tag) {
          if (this.tags[0]) {
            search_tag = this.tags[0].text;
          } else {
            search_tag = ":Not found"
          }

        }
        this.filtered_tag = search_tag;
        this.filtered_items = this.items.filter(data => {
          return data['tag'] === search_tag;
        });
        this.script = this.script.split(" ")[0] + " " + search_tag;

      },
      set_item(item) {
        this.search_item = item;
      },
      search_key() {
        this.script = this.search_item.name;
        this.fetch_search();
      },
      toogle_show(display_name) {
        this.$set(this.display_toggle, display_name, !this.display_toggle[display_name]);
      },
      upvote_downvote(type, uuid){
        const data = {   
          "uuid": uuid,
          "plus": type==="upvote"?'1':'0',
          "minus": type==="downvote"?'1':'0'
        }
        axios.post('https://0n7ecdnf2l.execute-api.us-east-1.amazonaws.com/Prod/global_installer_plus_minus',data, {
                headers: {
                        Authorization: 'Bearer '+store.state.id_token
                    }
            });
      }
    },
    mounted() {
      this.fetch_search();
      Prism.highlightAll();
    },
  }
</script>

<style scoped>
  .card {
    width: 100%;
    border-style: none;
  }

  .space-above-container {
    margin-top: 30px;
    text-align: center;
  }

  .space-above {
    margin-top: 60px;
    text-align: center;
  }

  .primary-text-color {
    color: #17a2b8;
  }

  .left-text-align {
    text-align: left;
    font-family: SFMono-Medium, "SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, monospace;
  }

  .table-code {
    border: 1px solid #ddd;
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
  }

  /* td>pre { */
    /* margin: 0px !important; */
  /* } */

  #text {
    margin: 0;
    padding: 0;
    height: 20px;
    width: 100px;
  }


</style>